<template>
  <div class="work-wrap">
    <div class="work-top-box">
      <div @click="backHandle">返回</div>
      <div class="cell" style="width: calc(100% - 160px); text-align: center">{{ detailData.faultName }}</div>
      <div v-if="detailData.isOverdue" style="color: #f56c6c">{{ detailData.statusName }}（超期）</div>
      <div v-else>{{ detailData.statusName }}</div>
    </div>

    <div class="work-center-box">
      <div class="work-detail-steps">
        <el-steps :space="200" :active="stepsStatus" align-center finish-status="success">
          <el-step title="工单下发"></el-step>
          <el-step title="工单处理"></el-step>
          <el-step title="工单审核"></el-step>
          <el-step title="工单完成"></el-step>
        </el-steps>
      </div>

      <div class="mt-10" style="overflow-y: auto; height: calc(100% - 155px)">
        <div class="work-card-box">
          <div class="work-title">
            <div class="title cell" style="font-weight: bold">工单基础信息</div>
          </div>
          <div class="work-content-box mt-10">
            <div class="">故障单号：{{ detailData.faultNo }}</div>
            <div class="mt-10">故障类型：{{ detailData.faultTypeName }}</div>
            <div class="mt-10">安装位置：{{ detailData.space }}</div>
            <div class="mt-10">
              设备名称：
              <span v-if="detailData.deviceList.length">
                <span v-for="(item, i) in detailData.deviceList" :key="i">
                  <span style="word-break: break-all; white-space: pre-wrap">{{ item.deviceName }}（{{ item.deviceNo }}）</span>
                  <span v-if="i < detailData.deviceList.length - 1">，</span>
                </span>
              </span>
              <span v-else>—</span>
            </div>
            <div class="mt-10">
              物联卡号：
              <span v-if="detailData.iccIdList.length">
                <span v-for="(item, i) in detailData.iccIdList" :key="i">
                  <span style="word-break: break-all; white-space: pre-wrap">{{ item }}</span>
                  <span v-if="i < detailData.iccIdList.length - 1">，</span>
                </span>
              </span>
              <span v-else>—</span>
            </div>
            <div class="mt-10">紧急程度：{{ detailData.urgencyLevelName }}</div>
            <div class="mt-10">截止日期：{{ detailData.handleEndTime }}</div>
            <div class="mt-10" style="word-break: break-all">故障备注：{{ detailData.faultDescription }}</div>
          </div>
        </div>

        <div v-for="(item, i) in detailData.infoResponseList" :key="i">
          <div class="work-card-box mt-10">
            <div class="work-title">
              <div class="title cell" style="font-weight: bold">工单处理信息</div>
            </div>
            <div class="work-content-box mt-10">
              <div class="">处理时间：{{ item.handleTime }}</div>
              <div class="mt-10">是否更换设备：{{ item.isReplaceDevice ? '是' : '否' }}</div>
              <div class="mt-10">新设备ID：{{ item.deviceId ? item.deviceId : '—' }}</div>
              <div class="mt-10">
                处理图片：
                <div style="display: flex; flex-wrap: wrap; align-items: center" class="mt-5">
                  <div v-for="(obj, j) in item.faultImages" :key="j" class="mr-10 mt-5">
                    <el-image style="width: 100px; max-height: 100px" :src="obj" :preview-src-list="item.faultImages"></el-image>
                  </div>
                </div>
              </div>
              <div class="mt-10" style="word-break: break-all">处理备注：{{ item.handleRemark }}</div>
            </div>
          </div>

          <div class="work-card-box mt-10">
            <div class="work-title">
              <div class="title cell" style="font-weight: bold">工单审核信息</div>
            </div>
            <div class="work-content-box mt-10">
              <div class="">审核时间：{{ reportList[i] && reportList[i].handleTime ? reportList[i].handleTime : '—' }}</div>
              <div class="mt-10">审核结果：{{ reportList[i] && reportList[i].nodeName ? reportList[i].nodeName : '—' }}</div>
              <div class="mt-10" style="word-break: break-all">处理备注：{{ reportList[i] && reportList[i].handleInfo ? reportList[i].handleInfo : '—' }}</div>
            </div>
          </div>
        </div>

        <div v-if="detailData.status == 1 || detailData.status == 2" class="detail-deal-btn mt-10" @click="dealHandle">处理工单</div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      stepsStatus: null,
      faultImages: [],
      detailData: {
        iccIdList: [],
        deviceList: [],
      },
      reportList: [],
      btn: '',

      wxReady: false, // 微信SDK是否已准备就绪
    };
  },
  activated() {
    console.log(this.$route.query);
    this.btn = this.$route.query.btn;
    this.getDetailData();
    this.initWeChatSDK();
  },
  methods: {
    // 初始化微信SDK配置
    async initWeChatSDK() {
      try {
        this.wxReady = false;
        let params = {
          url: window.location.href,
        };

        let res = await this.$http.get(this.$API.wechat_getSign, { params });
        const config = res.data;
        wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['chooseImage', 'uploadImage', 'getLocalImgData'],
        });
        wx.ready(() => {
          this.wxReady = true;
          console.log('微信SDK配置成功');
        });
        wx.error((res) => {
          console.error('微信SDK配置失败', res);
        });
      } catch (error) {
        console.error('获取微信签名失败', error);
      }
    },
    // 获取详情
    getDetailData() {
      let params = {
        orderId: this.$route.query.id,
      };
      this.$http.get(this.$API.repair_order_detail_with_device_relations, { params }).then((res) => {
        this.detailData = res.data || {};
        if (!this.detailData.infoResponseList) {
          this.detailData.infoResponseList = [];
        }

        if (this.detailData.infoResponseList.length) {
          this.detailData.infoResponseList.forEach((item, i) => {
            let faultImages = [];
            if (item.filesponseList && item.filesponseList.length) {
              item.filesponseList.forEach((obj) => {
                faultImages.push(obj.fileUrl);
              });
              this.$set(this.detailData.infoResponseList[i], 'faultImages', faultImages);
            }
          });
        }

        this.stepsStatus = this.detailData.status;
        if (this.stepsStatus == 3) {
          this.stepsStatus = 4;
        }
      });

      // 审核信息
      this.$http.get(this.$API.repair_order_audi_records, { params }).then((res) => {
        this.reportList = res.data || [];
      });
    },
    backHandle() {
      // this.$router.push({ path: '/fault/work', query: { btn: this.btn } });
      let url = '/fault/work?btn=' + this.btn;
      window.location.assign(url);
    },
    dealHandle() {
      let url = '/fault/work/detail/deal?id=' + this.$route.query.id + '&btn=' + this.btn;
      window.location.assign(url);
      // this.$router.push({ path: '/fault/work/detail/deal', query: { id: this.$route.query.id, btn: this.btn } });
    },
  },
};
</script>

<style lang="scss" scoped>
.work-wrap {
  height: 100%;
}
.work-top-box {
  display: flex;
  height: 50px;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  font-size: 1.6rem;
  padding: 0 10px;
}
.work-center-box {
  padding: 0 10px;
  height: 100%;
}
.work-card-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  .work-title {
    display: flex;
    .work-status {
      flex: 1 0 100px;
      text-align: right;
      font-size: 1.6rem;
    }
    .title {
      font-size: 1.6rem;
    }
  }
  .work-content-box {
    padding: 10px;
    font-size: 1.6rem;
    border-radius: 6px;
    background-color: #f9fafd;
  }
}
.detail-deal-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  color: #fff;
  background-color: #2f70ff;
  text-align: center;
}
</style>

<style lang="scss">
.work-detail-steps {
  background-color: #fff;
  margin-top: 10px;
  padding: 10px;
  .el-step__title {
    font-size: 1.6rem;
  }
  .el-step__icon {
    width: 20px;
    height: 20px;
  }
}
</style>
